// extracted by mini-css-extract-plugin
module.exports = {"empty-conversations":"style_empty-conversations__2L30A"};